import { GenIcon, IconType } from 'react-icons/lib';

const UfpbUserPC: IconType = (props: any) =>
  GenIcon({
    attr: {
      viewBox: '0 0 448 512',
    },
    child: [
      {
        attr: {
          d: 'M 224.31445 2.5390625 C 168.86882 2.5390625 123.93164 47.484083 123.93164 102.92188 C 123.93164 158.35966 168.86882 203.30469 224.31445 203.30469 C 279.76008 203.30469 324.69531 158.35966 324.69531 102.92188 C 324.69531 47.484083 279.76008 2.5390625 224.31445 2.5390625 z M 184.55273 240.94727 C 151.44936 240.94727 112.08354 252.81547 78.398438 272.49414 L 370.23242 272.49414 C 336.54795 252.81547 297.18104 240.94727 264.07422 240.94727 L 184.55273 240.94727 z M 49.005859 295.52344 C 42.260193 295.52344 36.309396 301.99249 36.830078 309.99414 L 49.005859 497.11523 C 49.526541 505.11688 54.437927 511.58594 61.183594 511.58594 L 387.44336 511.58594 C 394.18903 511.58594 399.10042 505.11688 399.62109 497.11523 L 411.79688 309.99414 C 412.31754 301.99249 406.36676 295.52344 399.62109 295.52344 L 49.005859 295.52344 z M 431.44727 328.49609 L 426.77344 402.88086 C 438.11326 399.62787 446.45313 389.28891 446.45312 376.85547 C 446.45312 359.81669 440.87727 343.52563 431.44727 328.49609 z M 17.179688 328.49805 C 7.7497659 343.52713 2.1738281 359.8173 2.1738281 376.85547 C 2.1738281 389.2438 10.516806 399.58704 21.851562 402.86328 L 17.179688 328.49805 z M 224.31445 387.34961 A 17.04385 16.204731 0 0 1 241.35742 403.55469 A 17.04385 16.204731 0 0 1 224.31445 419.75977 A 17.04385 16.204731 0 0 1 207.26953 403.55469 A 17.04385 16.204731 0 0 1 224.31445 387.34961 z ',
        },
        child: [],
        tag: 'path',
      },
    ],
    tag: 'svg',
  })(props);

export default UfpbUserPC;
